import { Controller, useFormContext } from 'react-hook-form'

import { Box } from '@factorialco/deprecated-design-system'

import NumberField from 'modules/core/components/NumberField'
import i18n from 'modules/core/lib/i18n'

import { castError } from '../../../castError'
import withCustomizationFields, {
  WithCustomizationFieldsProps,
} from '../../../withCustomizationFields'
import withFieldPermissions, { WithFieldPermissionsProps } from '../../../withFieldPermissions'

const FIELD_NAME = 'mileage'

interface Props extends WithCustomizationFieldsProps, WithFieldPermissionsProps {}

const MileageField = ({ isFieldReadOnly, isFieldMandatory }: Props) => {
  const {
    control,
    watch,
    formState: { errors },
  } = useFormContext()

  const units = watch('units')
  return (
    <Box width="full">
      <Controller
        name={FIELD_NAME}
        control={control}
        render={({ field }) => (
          <NumberField
            label={i18n.t('expenses_v2.forms.fields.mileage.label')}
            value={field.value}
            indicator={units}
            maxDecimals={2}
            placeholder={'0'}
            mandatory={isFieldMandatory ?? false}
            readonly={isFieldReadOnly}
            onChange={(value) => {
              field.onChange(value)
            }}
            error={castError(errors?.mileage)}
          />
        )}
      />
    </Box>
  )
}

export default withCustomizationFields(withFieldPermissions(MileageField, FIELD_NAME))
